import React from "react";
import "./ForInfluencersBrandGuidelines.scss";

export const ForInfluencersBrandGuidelines: React.FC = () => {
    const palettes = [
        {
            color: '#FF4D07',
        },
        {
            color: '#97008A',
        },
        {
            color: '#DA0FFE'
        },
        {
            color: '#F883FF',
        },
        {
            color: '#2AD44E',
        },
        {
            color: '#FFF600'
        },
        {
            color: '#00D1FF',
        },
        {
            color: '#000053',
            border: true,
        },
    ];

    return (
        <div className="brand-guidelines">
            <div className="brand-guidelines-header">
                <p className="brand-guidelines-title">
                    Fonts:
                </p>
                <p className="brand-guidelines-subtitle">
                    We use font family “Roboto”. Download here:
                </p>
                <a href="https://fonts.google.com/specimen/Roboto" target="_blank" className="brand-guidelines-link">
                    https://fonts.google.com/specimen/Roboto
                </a>
            </div>
            <div className="brand-guidelines-content">
                <p className="brand-guidelines-title">
                    Our palette:
                </p>
                <div className="palette-list">
                    {palettes.map((palette) => (
                        <div className="palette" key={palette.color}>
                            <div
                                className={'palette-color' + ' ' + (palette.border ? 'bordered' : '')}
                                style={{ backgroundColor: palette.color }}
                            />
                            <p className="palette-title">{palette.color}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}